import { AutomationProcessListAPIModel, PaginatedAPI } from 'src/models/api.model'

export interface AutomationProcessRegisterState {
  automationRegisterList: PaginatedAPI<AutomationProcessListAPIModel>
}

export const initialAutomationRegisterState: AutomationProcessRegisterState = {
  automationRegisterList: undefined
}
